import * as types from './mutation_types';

export default {
  [types.TESTIMONIAL_SHOW_RESET](state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      retrieved: null,
    });
  },

  [types.TESTIMONIAL_SHOW_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.TESTIMONIAL_SHOW_SET_RETRIEVED](state, retrieved) {
    Object.assign(state, { retrieved });
  },

  [types.TESTIMONIAL_SHOW_TOGGLE_LOADING](state) {
    Object.assign(state, { error: '', isLoading: !state.isLoading });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/testimonial/show/mutations.js